import { render, staticRenderFns } from "./JSelectXuezhi.vue?vue&type=template&id=68582f62&scoped=true"
import script from "./JSelectXuezhi.vue?vue&type=script&lang=js"
export * from "./JSelectXuezhi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68582f62",
  null
  
)

export default component.exports